module.exports = __webpack_public_path__ + "static/media/01_asahid88940c90623f6c5c7134fca195c8766.webp";